import { writable, type Writable } from "svelte/store";

interface StoreProps {
	showing: boolean;
	title: string;
	message?: string;
	confirmButtonText: string;
	enabled: boolean;
	danger: boolean;
	onConfirm: () => Promise<void>;
	onClose?: () => void;
}

interface ConfirmationStore extends Writable<StoreProps> {
	showConfirmation(
		title: string,
		message: string,
		confirmButtonText: string,
		onConfirm: () => void | Promise<void>,
		onClose?: () => void,
		danger?: boolean
	): void;
	hideConfirmation(): void;
	disable(): void;
	enable(): void;
}

// This is a singletone store...
const store = createStore();

export function getConfirmationStore(): ConfirmationStore {
	return store;
}

function createStore(): ConfirmationStore {
	const store = writable<StoreProps>({
		showing: false,
		title: "",
		onConfirm: async () => {},
		confirmButtonText: "Ok",
		enabled: true,
		danger: false
	});
	return {
		subscribe: store.subscribe,
		set: store.set,
		update: store.update,
		hideConfirmation() {
			store.update((value) => {
				return {
					danger: false,
					showing: false,
					enabled: true,
					title: "",
					confirmButtonText: "Ok",
					onClose: () => {},
					onConfirm: async () => {}
				};
			});
		},
		showConfirmation(
			title: string,
			message: string,
			confirmButtonText: string,
			onConfirm: () => Promise<void>,
			onClose?: () => void,
			danger?: boolean
		) {
			store.update((value) => {
				return {
					danger: !!danger,
					showing: true,
					enabled: true,
					title,
					message,
					confirmButtonText,
					onConfirm,
					onClose
				};
			});
		},
		disable() {
			store.update((value) => {
				return {
					...value,
					enabled: false
				};
			});
		},
		enable() {
			store.update((value) => {
				return {
					...value,
					enabled: true
				};
			});
		}
	};
}
